

import { Vue, Component, Watch, Prop } from 'vue-property-decorator'

@Component({
    components: {

    },
})
export default class ItemLeftHolder extends Vue {
    @Prop({ type: String, default: null }) readonly name!: string;
}
